export default __webpack_public_path__ + "static/media/GT-Ultra-Standard-Ultra.9925134b.ttf";